// Since this component could be contained within an anchor element (i.e. react-router Link)
// we need to ensure that any click handlers don't let events bubble up to the anchor
export const createHandler = (callback, e) => {
  e.preventDefault()
  e.stopPropagation()
  callback()
}
